import { createStore } from 'redux'

function selectOptionsreducer(state, action) {
    state = action['data'] ? action['data'] : [];
    return state;

}

let optionsStore = createStore(selectOptionsreducer)



function excludesTablereducer(state, action) {
    state = action['data'] ? action['data'] : [];
    return state;

}
let excludesTableStore = createStore(excludesTablereducer)


function selectedPackagesreducer(state, action) {
    state = action['data'] ? action['data'] : [];
    return state;

}
let selectedPackagesStore = createStore(selectedPackagesreducer)



function excludesUpdateTablereducer(state, action) {
    state = action['data'] ? action['data'] : [];
    return state;

}
let excludesUpdateTableStore = createStore(excludesUpdateTablereducer)



export { optionsStore, excludesTableStore, selectedPackagesStore,excludesUpdateTableStore }